import React from "react";
import { WidgetProps } from "@rjsf/core";
import { DropdownItemProps } from "semantic-ui-react";
import { useSchemaTranslation } from "../../../useSchemaTranslation";

export const DropdownDisplay: React.FC<WidgetProps> = ({ id, value, options }) => {
    const { t } = useSchemaTranslation();
    const dropdownItems: DropdownItemProps[] = Array.isArray(options.options)
        ? options.options
        : [];

    const valueOption = dropdownItems.find((v) => v.value === value);

    const valueText = valueOption
        ? valueOption.text
        : `Tuntematon arvo ${value}`;

    return (
        <div id={id} className="DropdownDisplay">
            <p>{typeof valueText === "string" ? t(valueText) : valueText}</p>
        </div>
    );
}
